/**
 * Sticky Layout System
 * ---------------------
 * 1. Dynamically measures announcement bar & header heights → sets CSS vars
 * 2. Neutralises the theme's hide-on-scroll (`is-out` class) so header is always visible
 * 3. Manages group header stacking via IntersectionObserver
 */
(function () {
  'use strict';

  /* ---- Utility ---- */
  const root = document.documentElement;

  function getHeight(el) {
    return el ? el.getBoundingClientRect().height : 0;
  }

  /* ---- Height calculation ---- */
  function updateStickyHeights() {
    // Target the section wrapper to get the true height
    const utilityBar = document.querySelector('#shopify-section-announcement_bar_utility_hXgGGM') || document.querySelector('.shopify-section:has(.utility-bar)') || document.querySelector('.utility-bar');
    const header = document.querySelector('.cc-header--sticky') || document.querySelector('#shopify-section-header') || document.querySelector('store-header');

    const utilityH = getHeight(utilityBar);
    const headerH = getHeight(header);

    root.style.setProperty('--utility-bar-height', utilityH + 'px');
    root.style.setProperty('--header-section-height', headerH + 'px');
    root.style.setProperty('--sticky-offset', (utilityH + headerH) + 'px');
  }

  /* ---- Neutralise hide-on-scroll ---- */
  function preventHeaderHide() {
    const header = document.querySelector('store-header[data-is-sticky]');
    if (!header) return;

    // Remove is-out immediately if it was already set
    header.classList.remove('is-out');

    // Observe class changes and remove is-out when the theme adds it
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            if (header.classList.contains('is-out')) {
              header.classList.remove('is-out');
            }
          }
        });
      });
      observer.observe(header, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ---- Group header stacking via IntersectionObserver ---- */
  function initGroupHeaders() {
    var groupHeaders = document.querySelectorAll('.sticky-group-header');
    if (!groupHeaders.length) return;

    // Calculate offset = utility bar height + header height + small buffer
    function getStickyTop() {
      var utilityH = parseFloat(getComputedStyle(root).getPropertyValue('--utility-bar-height')) || 0;
      var headerH = parseFloat(getComputedStyle(root).getPropertyValue('--header-section-height')) || 0;
      return utilityH + headerH + 2; // 2px buffer
    }

    // Use IntersectionObserver to detect when a group header becomes stuck
    var observerOptions = {
      root: null,
      threshold: [0, 1],
      rootMargin: '-' + getStickyTop() + 'px 0px 0px 0px'
    };

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        if (entry.intersectionRatio < 1 && entry.boundingClientRect.top <= getStickyTop()) {
          el.classList.add('is-stuck');
        } else {
          el.classList.remove('is-stuck');
        }
      });
    }, observerOptions);

    groupHeaders.forEach(function (header) {
      observer.observe(header);
    });
  }

  /* ---- Initialisation ---- */
  function init() {
    updateStickyHeights();
    preventHeaderHide();
    initGroupHeaders();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Recalculate on resize (using the theme's debounced resize event if available)
  window.addEventListener('on:debounced-resize', updateStickyHeights);
  window.addEventListener('resize', function () {
    // Fallback: update after a short delay
    clearTimeout(window._stickyResizeTimer);
    window._stickyResizeTimer = setTimeout(updateStickyHeights, 250);
  });

  // Recalculate after Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 300);
  });
  document.addEventListener('shopify:section:reorder', function () {
    setTimeout(init, 300);
  });
})();
